module.exports = __webpack_public_path__ + "static/media/message.7eea501f.png";